import { formatDate, nextMonth } from '@/utils/time';

export const auth = {
  username: null,
  password: null,
};

export const twoFA = {
  code: null,
};

export const profile = {
  email: null,
  first_name: null,
  last_name: null,
  mobile: null,
  medical_conditions: [],
  scalp_conditions: [],
};

// A function, not a plain object: this module is only evaluated once when
// the JS bundle loads, so a static `new Date()` here would freeze at
// whatever day the page was first opened - on a shop tablet left open for
// days, every new upload silently defaulted to that stale date instead of
// today. Callers must invoke media() to get a fresh date each time.
export const media = () => ({
  date: formatDate(new Date(), 'dd/MM/yyyy'),
  name: null,
  media: null,
});

export const password = {
  password: null,
  password_confirmation: null,
};

export const shop = {
  address: '',
  country: 'Singapore',
  name: '',
  telephone_no: '',
};

export const user = {
  email: null,
  first_name: null,
  last_name: null,
  mobile: null,
  medical_conditions: [],
  scalp_conditions: [],
  password:
    Math.random()
      .toString(36)
      .substring(4, 8) +
    Math.random()
      .toString(36)
      .substring(4, 8),
  role: 'customer',
  shop_id: null,
};
